import { useQuery } from "@tanstack/react-query";
import React, { useContext, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { PhotoProvider, PhotoView } from "react-photo-view";
import { AuthContext } from "../../../contexts/AuthProvider";
import Loading from "../../Shared/Loading/Loading";
import Lottie from "lottie-react";
import profile from "../../../profile.json";
import UpdateProfileModal from "../UpdateProfileModal/UpdateProfileModal";

const Dashboard = () => {
   const { user } = useContext(AuthContext);

   const [time, setTime] = useState(null);
   const [updateProfile, setUpdateProfile] = useState(null);

   const {
      data: users = [],
      isLoading,
      refetch,
   } = useQuery({
      queryKey: ["users"],
      queryFn: async () => {
         const res = await fetch("https://recycle-hut-server.vercel.app/users");
         const data = await res.json();
         return data;
      },
   });

   setInterval(() => setTime(new Date().toLocaleTimeString()), 1000);

   const currentUser = users.find((u) => u?.email === user?.email);

   if (isLoading) {
      return <Loading></Loading>;
   }

   return (
      <div
         className="md:flex flex-row-reverse justify-between items-center gap-16 
      w-[90%] md:w-[w-100%] mx-auto h-[100vh] md:h[80vh] lg:h-[90vh] mb-[70px] md:mb-0"
      >
         <div
            className="w-full md:mt-[-55px]"
            data-aos="fade-down-left"
            data-aos-duration="2000"
         >
            <div className="w-[80%] mb-6 md:mb-0 md:w-[80%] lg:w-[73%] mx-auto">
               <Lottie
                  animationData={profile}
                  loop={true}
                  className="my-transition-5"
               />
            </div>

            <div className="text-[19.5px] md:text-[22px] mt-[-70px] md:mt-[-55px] text-center">
               <span className="text-[14px]">Now</span>
               <span className="text-cyan-600 font-semibold"> {time}</span>
            </div>
         </div>

         <div className="w-full"
            data-aos="fade-down-right"
            data-aos-duration="2000"
         >
            <div className="text-center flex flex-col justify-center items-center gap-4 mt-[55px] md:mt-0">
               <div className="my-transition-4">
                  <PhotoProvider
                     speed={() => 800}
                     easing={(type) =>
                        type === 2
                           ? "cubic-bezier(0.36, 0, 0.66, -0.56)"
                           : "cubic-bezier(0.34, 1.56, 0.64, 1)"
                     }
                  >
                     <PhotoView src={currentUser?.image}>
                        <figure>
                           <LazyLoadImage
                              src={currentUser?.image}
                              alt={currentUser?.name}
                              className="rounded-full w-40 h-40 object-cover"
                              placeholderSrc={currentUser?.image}
                              effect="blur"
                              title={currentUser?.name}
                              style={{ cursor: "pointer" }}
                           />
                        </figure>
                     </PhotoView>
                  </PhotoProvider>
               </div>
               <div className="mt-[-3px]">
                  <label
                     className="btn btn-sm btn-outline btn-secondary font-bold my-transition-4"
                     htmlFor="update-profile-modal"
                     onClick={() => setUpdateProfile(currentUser)}
                  >
                     Update Profile
                  </label>
               </div>
            </div>
            <div className="text-[22px] font-semibold mt-3 flex justify-center items-center w-[85%] lg:w-[90%] mx-auto">
               <span className="text-center my-transition-4">
                  Hi!
                  <span className="font-bold text-green-500 text-[21px] ml-[6px]">
                     {currentUser?.name}
                  </span>
                  <br /> Welcome to your
                  <span className="font-extrabold text-fuchsia-500 mx-2">
                     {currentUser?.role}
                  </span>
                  dashboard <br />
                  <small>
                     <span>
                        Your email address is:{" "}
                        <span className="text-blue-600">{currentUser?.email}</span>
                     </span>
                  </small>
               </span>
            </div>
         </div>

         {updateProfile && (
            <UpdateProfileModal
               updateProfile={updateProfile}
               setUpdateProfile={setUpdateProfile}
               refetch={refetch}
            ></UpdateProfileModal>
         )}
      </div>
   );
};

export default Dashboard;
